import { ScrollPanel } from "primereact/scrollpanel";
import { Calendars } from "./Calendars";
import { Panel } from "primereact/panel";
import { CalendarPropertyEditor } from "./CalendarPropertyEditor";

export function CalendarEditor({GCalendar}) {
    if (!GCalendar) {
        return ('Wybierz kalendarz z listy po lewej');
    }

    return (
        <div className="flex">
            <CalendarPropertyEditor GCalendar={GCalendar}></CalendarPropertyEditor>
            <ScrollPanel style={{height: '84vh'}} className="col-6">
                <Calendars serviceId={GCalendar.service_id}></Calendars>
            </ScrollPanel>
        </div>
        
    )
}